// src/components/AuthPage.jsx
import React from "react";
import { Box, Flex, Heading, Text, Container } from "@chakra-ui/react";
// v3 color-mode shim (adjust path if yours differs)
import { useColorMode } from "./ui/color-mode";

export default function AuthPage({ title, subtitle, children }) {
  const { colorMode } = useColorMode();

  // Page uses pure white in light mode, deep gray in dark mode
  const pageBg = colorMode === "light" ? "white" : "gray.900";

  // Card + header styling
  const cardBg = colorMode === "light" ? "white" : "gray.800";
  const borderColor = colorMode === "light" ? "gray.200" : "whiteAlpha.300";
  const headerGradient =
    colorMode === "light"
      ? "linear(to-r, brand.500, brand.700)"
      : "linear(to-r, blue.500, blue.700)";

  return (
    <Flex minH="100vh" align="center" justify="center" bg={pageBg} px={4}>
      <Container maxW="lg">
        <Box
          bg={cardBg}
          borderWidth="1px"
          borderColor={borderColor}
          borderRadius="2xl"
          boxShadow="xl"
          overflow="hidden"
        >
          {/* Header */}
          <Box bgGradient={headerGradient} color="white" px={6} py={6} textAlign="center">
            <Heading size="lg" fontWeight="bold">
              {title}
            </Heading>
            {subtitle && (
              <Text mt={2} fontSize="md" opacity={0.9}>
                {subtitle}
              </Text>
            )}
          </Box>

          {/* Form Content */}
          <Box p={{ base: 6, md: 8 }}>{children}</Box>
        </Box>
      </Container>
    </Flex>
  );
}